import React from "react";

const Dashboard = () => {
  return (
    <div>
      <h2 className="page-header">Dashboard</h2>
    </div>
  );
};

export default Dashboard;
